const enTranslation = {
  Action: 'Action',
  Consumable_Orders: 'Consumable Orders',
  Certificate: 'Certificate',
  'Job Name': 'Job Name',
  Status: 'Status',
  Received: 'Received',
  'Due Date': 'Due Date',
  Completed: 'Completed',
  'Project Code': 'Project Code',
  '# Sample': '# Sample',
  'First Sample': 'First Sample',
  'Last Sample': 'Last Sample',
  'Sample Type': 'Sample Type',
  Client: 'Client',
  'PO Number': 'PO Number',
  '# Samples': '# Samples',
  'Start Date': 'Start Date',
  'Received On': 'Received On',
  Laboratory: 'Laboratory',
  Office: 'Office',
  'Order Number': 'Order Number',
  Project: 'Project',
  'Shipment ID': 'Shipment ID',
  Started: 'Started',
  'First Reported': 'First Reported',
  'Last Reported': 'Last Reported',
  'Job Description': 'Job Description',
  Analytes: 'Analytes',
  Units: 'Units',
  'Detection Limit': 'Detection Limit',
  Method: 'Method',
  InProgress: 'In-Progress',
  Scheduled: 'Scheduled',
  'Spec Met': 'Spec Met',
  'Out of Spec': 'Out of Spec',
  Total: 'Total',
  Maximize: 'Maximize',
  Minimize: 'Minimize',
  'Created On': 'Created On',
  'Job Status': 'Job Status',
  Location: 'Location',
  Supplier: 'Supplier',
  'Sample Name': 'Sample Name',
  'Job Number': 'Job Number',
  Sequence: 'Sequence',
  'Sample Location': 'Sample Location',
  Source: 'Source',
  Brand: 'Brand',
  'Date Received': 'Date Received',
  'Sampling Date': 'Sampling Date',
  'Report(s)': 'Report(s)',
  'SpecMet/NotMet': 'Spec Met/Not Met',
  Description: 'Description',
  Approved: 'Approved',
  'Site Country': 'Site Country',
  Job: 'Job',
  'Job Progress': 'Job Progress',
  Deliverables: 'Deliverables',
  'Laboratory Report': 'Laboratory Report',
  'Data Files': 'Data Files',
  Invoices: 'Invoices',
  'Other Documents': 'Other Documents',
  Site: 'Site',
  'Sample Date': 'Sample Date',
  'Component Age': 'Component Age',
  'Filter Changed': 'Filter Changed',
  'Sample Number': 'Sample Number',
  'Action Number': 'Action Number',
  'Action Owner': 'Action Owner',
  'Action Type': 'Action Type',
  'Action Status': 'Action Status',
  'Belongs To': 'Belongs To',
  'Record ID': 'Record ID',
  Created: 'Created',
  'Started On': 'Started On',
  'Started By': 'Started By',
  'Completed On': 'Completed On',
  'Client Name': 'Client Name',
  'Client Worksite': 'Client Worksite',
  'Client Address': 'Client Address',
  'Lab No': 'Lab No',
  'Received Date': 'Received Date',
  'Completion Date': 'Completion Date',
  'Tracking No': 'Tracking No',
  'Reference No': 'Reference No',
  'Work Order No': 'Work Order No',
  'PO No': 'PO No',
  'Make Up Oil Amount': 'Make Up Oil Amount',
  Port: 'Port',
  'IMO No': 'IMO No',
  'Engine Hours': 'Engine Hours',
  'Engine Type': 'Engine Type',
  'No of Cylinders': 'No of Cylinders',
  'Total No of Samples': 'Total No of Samples',
  'Date Sampled': 'Date Sampled',
  'Date Landed': 'Date Landed',
  'Date Reported': 'Date Reported',
  'Percent of MCR (PCT)': 'Percent of MCR (PCT)',
  'Max Speed rpm': 'Max Speed rpm',
  'Max Output KW': 'Max Output KW',
  'Max Output': 'Max Output',
  'Actual Speed rpm': 'Actual Speed rpm',
  'Actual Output KW': 'Actual Output KW',
  Asset: 'Asset',
  'Asset Part': 'Asset Part',
  Fluid: 'Fluid',
  AssetID: 'AssetID',
  'Asset Mfg': 'Asset Mfg',
  'Asset Model': 'Asset Model',
  'Asset Serial No': 'Asset Serial No',
  'Asset Worksite': 'Asset Worksite',
  'Asset Part Mfg': 'Asset Part Mfg',
  'Asset Part Model': 'Asset Part Model',
  'Asset Part Serial No': 'Asset Part Serial No',
  'Asset Part Type': 'Asset Part Type',
  Manufacturer: 'Manufacturer',
  Grade: 'Grade',
  Parameter: 'Parameter',
  Spec: 'Spec',
  Result: 'Result',
  'Result Unit': 'Result Unit',
  'Reported Date': 'Reported Date',
  'Sampled Date': 'Sampled Date',
  'Batch/Barcode No': 'Batch/Barcode No',
  Type: 'Type',
  Company: 'Company',
  Address: 'Address',
  Phone: 'Phone',
  Email: 'Email',
  Reports: 'Reports',
  Quantity: 'Quantity',
  'Sample Sequence': 'Sample Sequence',
  'Prep Code': 'Prep Code',
  'Analytical Package or Elements Requested': 'Analytical Package or Elements Requested',
  Controls: 'Controls',
  'File Name': 'File Name',
  'Inbound ID': 'Inbound ID',
  'Processed On': 'Processed On',
  'Ext System Code': 'Ext System Code',
  'Created On From': 'Created On From',
  'Created On To': 'Created On To',
  'Spec Met/ Not Met': 'Spec Met/ Not Met',
  Name: 'Name',
  Component: 'Component',
  Position: 'Position',
  Model: 'Model',
  'Serial Number': 'Serial Number',
  'Fuel Type': 'Fuel Type',
  'Oil Manufacturer': 'Oil Manufacturer',
  'Oil Brand': 'Oil Brand',
  'Oil Grade': 'Oil Grade',
  'Oil Capacity': 'Oil Capacity',
  'Oil Unit': 'Oil Unit',
  'Cooling System type': 'Cooling System type',
  Sample: 'Sample',
  'Next Sample': 'Next Sample',
  Frequency: 'Frequency',

  Nav_Menu_Home: 'Home',
  Nav_Menu_Consumable_Orders: 'Consumable Orders',
  Nav_Menu_Dashboard_Mineral: 'Dashboard Mineral',
  Nav_Menu_Dashboard_PetroHub: 'Dashboard PetroHub',
  Nav_Menu_Dashboard_Food: 'Dashboard Food',
  Nav_Menu_Dashboard_FQT: 'Dashboard FQT',
  Nav_Menu_Dashboard_BVAQ: 'Dashboard BVAQ',
  Nav_Menu_Knowledge_Center: 'Knowledge Center',
  Nav_Menu_Trending: 'Trending',
  Nav_Menu_Jobs_And_Samples: 'Jobs & Samples',
  Nav_Menu_Jobs: 'Jobs',
  Nav_Menu_Jobs_Details: 'Job Details',
  Nav_Menu_Samples: 'Samples',
  Nav_Menu_SampleTracking: 'Sample Tracking',
  Nav_Menu_Reports_And_Invoices: 'Reports & Invoices',
  Nav_Menu_Invoices: 'Invoices',
  Nav_Menu_Reports: 'Reports',
  Nav_Menu_Administrator: 'Administrator',
  Nav_Menu_Documents: 'Documents',
  Nav_Menu_Feedback: 'Feedback',
  Nav_Menu_News: 'News',
  Nav_Menu_Roles: 'Roles',
  Nav_Menu_Users: 'Users',
  Nav_Menu_NotificationTemplate: 'Notification Templates',
  Nav_Menu_Alerts: 'Alerts',
  Nav_Menu_UserGroups: 'User Groups',
  Nav_Menu_ObjectConfiguration: 'Object Configuration',
  Nav_Menu_Clients: 'Clients',
  Nav_Menu_InspectionLocations: 'Inspection Locations',

  Nav_Client_Quotes: 'Client Quotes',
  Nav_Equipments: 'Equipments',
  Nav_Actions: 'Actions',
  Nav_Menu_ClientQuotes: 'Client Quotes',
  Nav_Menu_Equipments: 'Equipments',
  Nav_Menu_Submission: 'SUBMISSION',
  Nav_Menu_Data_Schema: 'Data Schema',
  Nav_Menu_Time_Log_Calculation: 'Time Log Calculations',
  Nav_Menu_Subscriptions: 'Subscriptions',
  Nav_Menu_SampleSubmission: 'Submissions',
  Nav_Sample_Submission: 'Submissions',
  Nav_Menu_Target: 'Target',
  Nav_Menu_Statistics: 'Statistics',
  Nav_Menu_API: 'API',
  Nav_Menu_TranslationSets: 'Translation Sets',
  Nav_Menu_MyActions: 'My Actions',
  Nav_Menu_ActionCenter: 'Action Center',
  Nav_Menu_APILog: 'API Log',
  Nav_Menu_AssetManagement: 'Asset Management',
  Nav_Menu_Equipment: 'Equipment',
  Nav_Menu_EquipmentBrowse: 'Browse Equipments',
  Nav_Menu_Outbound: 'Outbound',
  Nav_Menu_Export: 'Export',
  Nav_Menu_Timestamp_Event: 'Timestamp Event',
  Nav_Menu_Quantity_Display_Group: 'Quantity Display Group',
  Nav_Menu_Cylinders_And_Supplies: 'Cylinders',
  Nav_Menu_Cylinders: 'Cylinders',
  Nav_Menu_Orders: 'Orders',
  Nav_Order: 'Order',
  Nav_Menu_OrderRequest: 'Order Request',
  NewUser: 'New User',
  UserList: 'User List',
  Search: 'Search',
  All: 'All',
  News: 'News',

  Header_Home: 'Home',
  Header_ConsumableOrders: 'Consumable Orders',
  Header_SampleSearch: 'Samples',
  Header_SampleTracking: 'Sample Tracking',
  Header_SampleTrackingSearch: 'Sample Tracking Search',
  // Header_SampleTrackingDetails: 'Tracking Details',
  // Header_SampleTrackingInfo: 'Sample Tracking Details',
  Header_ActionsSearch: 'Actions',
  Header_JobSearch: 'Jobs',
  Header_SampleDetails: 'Sample Details',
  Header_SampleInfo: 'Sample Info',
  Header_Results: 'Results',
  Header_JobInfo: 'Job Info',
  Header_InPrep: 'IN PREP',
  Header_InTransit: 'IN TRANSIT',
  Header_InAnalysis: 'IN ANALYSIS',
  Header_JobAge: 'JOB AGE',
  Header_SampleAge: 'SAMPLE AGE',
  Header_In: 'IN',
  Header_Out: 'OUT',
  Header_RecentNews: 'Recent News',
  Header_JobProgress: 'Job Progress',
  Header_SampleProgress: 'Sample Progress',
  Header_RoleSearch: 'Roles',
  Header_NewsSearch: 'News',
  Header_DocumentSearch: 'Documents',
  Header_Document: 'Document',
  Header_AddDocument: 'Add New Document',
  Header_EditDocument: 'Edit Document',
  Header_EditUserGroups: 'Edit User Groups',
  Header_UserGroups: 'User Groups',
  Header_UserGroup: 'User Group',
  Header_News: 'News',
  Header_General: 'General',
  Header_Access: 'Access',
  Header_KnowledgeCenter: 'Knowledge Center',
  Header_Documents: 'Documents',
  Header_AccountSetting: 'Account Settings',
  Header_Profile: 'Profile',
  Header_ReportSearch: 'Reports',
  Header_Analysis: 'Analysis',
  Header_Trending: 'Trending',
  Header_MyActions: 'My Actions',
  Header_InvoiceSearch: 'Invoices',
  Header_NotificationSetting: 'Notification Templates',
  Header_Triggers: 'Triggers',
  Header_Templates: 'Templates',
  Header_Template: 'Template',
  Header_Roles: 'Roles',
  Header_Permissions: 'Permissions',
  Header_NotificationsFor: 'Notifications for',
  Header_InvoiceInfo: 'Invoice Info',
  Header_Conditions: 'Conditions',
  Header_User: 'User',
  Header_UserInfo: 'User Info',
  Header_UserSearch: 'Users',
  Header_TimeLogCalculation: 'Time Log Calculation',
  Header_UserEdit: 'User Edit',
  Header_UserCreate: 'User Create',
  Header_AttachedDocuments: 'Attached Documents',
  Header_InvoiceDetail: 'Invoice Detail',
  Header_OrderInvoiceDetail: 'Order Invoice Detail',
  Header_OrderDetails: 'Order Details',
  Header_FeedbackSearch: 'Feedback',
  Header_JobDetail: 'Job Detail',
  Header_SamplePreparationAndAnalyticalProcedures:
    'Sample Preparation And Analytical Procedures',
  Header_JobQuantityData: 'Quantity Data',
  Header_JobQuantityDataCalculation: 'Quantity Data Calculation',
  Header_JobTimeLogCalculation: 'Time Log Calculation',
  Header_JobStorageInformation: 'Job Storage Information',
  Header_SampleStorageInformation: 'Sample Storage Information',
  Header_Deliverables: 'Deliverables',
  Header_Alerts: 'Alerts',
  Header_Attachments: 'Attachments',
  Header_Result_History: 'Result History',
  Header_Status: 'Status',
  Header_Actions: 'Actions',
  Header_ClientQuotes: 'Client Quotes',
  Header_Equipments: 'Equipments',
  Header_AddClientQuotes: 'New Client Quotes',
  Header_EditClientQuotes: 'Edit Client Quotes',
  Header_DataSchema: 'Data Schema',
  Header_JobMessages: 'Job Messages',
  Header_Subscriptions: 'Subscriptions',
  Header_EditSchema: 'Edit Schema',
  Header_AddSubmission: 'New Sample Submission',
  Header_EditSubmission: 'Edit Sample Submission',
  Header_Submission: 'Submissions',
  Header_Targets: 'Targets',
  Header_Statistics: 'Statistics',
  Header_EditTarget: 'Edit Target',
  Header_TranslationSets: 'Translation Sets',
  Header_EditTranslationSets: 'Edit Translation Sets',
  Header_EditSubscription: 'Outgoing Subscription',
  Header_Action_Column_New: 'To do',
  info_PermissionName_and_PermissionCode_CanNotBeEmpty: 'Permission Name and Permission Code Can Not Be Empty',
  Header_Action_Column_InProgress: 'In Progress',
  Header_Action_Column_Completed: 'Completed',
  Header_APILog: 'API Log',
  Header_Sample_Results_History: 'Sample Results History',
  Header_Lubrication: 'Lubrication',
  Header_CylinderOil: 'Cylinder Oil',
  Header_Assets: 'Assets',
  Header_Add_New_Widget: 'Add New Widget',
  Header_AssetManagement: 'Asset Management',
  Header_VesselInformation: 'Vessel Information',
  Header_ClientDetails: 'Client Details',
  Header_ClientSiteDetails: 'Client Site Details',
  Header_Equipment_Details: 'Equipment Details',
  Header_Recommendation: 'Recommendation',
  Header_Graphs: 'Graphs',
  Header_ChartsAndGraphs: 'Graph / Chart',
  Header_NoAssetName: 'No Asset Name',
  Header_SubmissionDetails: 'Submission Details',
  Header_SubmissionContacts: 'Submission Contacts',
  Header_SampleList: 'Sample List',
  Header_InvoiceDetailList: 'Invoice Detail List',
  Header_ComponentList: 'Component List',
  Header_EquipmentList: 'Equipment List',
  Header_ComponentDetails: 'Component Details',
  Header_UserGroupInformation: 'User Group Information',
  Header_ObjectConfiguration: 'Object Configuration',
  Header_GeneralInfo: 'General Info',
  Header_AddObjectConfiguration: 'Add Object Configuration',
  Header_EditObjectConfiguration: 'Edit Object Configuration',
  Header_AddTimeLogCalculation: 'Add Time Log Calculation',
  Header_EditTimeLogCalculation: 'Edit Time Log Calculation',
  Header_TimeLogCalculationInfo: 'Time Log Calculation Information',
  Header_Outbound: 'Outbound',
  Header_Export: 'Export',
  Header_Progress: 'Progress',
  Header_Client: 'Client',
  Header_Parcel: 'Parcel',
  Header_Clients: 'Clients',
  Header_InspectionLocations: 'Inspection Locations',
  Header_AddInspectionLocation: 'Add Inspection Location',
  Header_EditInspectionLocation: 'Edit Inspection Location',
  Header_InspectionLocationInfo: 'Inspection Location Info',
  Header_LaboratorySamplesAndResults: 'Laboratory Samples & Results',
  info_Permission_SaveSuccessfully: 'Permission Save Successfully',
  Header_QuantityDisplayGroups: 'Quantity Display Groups',
  Header_AddTimestampEvent: 'Add Timestamp Event',
  Header_EditTimestampEvent: 'Edit Timestamp Event',
  Header_TimestampEventInformation: 'Timestamp Event Information',
  Header_OnOff: 'On/Off',
  Header_AssociateContractList: 'Associate Contract List',
  Header_EditConsumables: 'Consumable Orders',
  Header_MarineFuel: 'Marine Fuel',
  Header_VerifuelBenefits: 'Verifuel Benefits',
  Header_VerifuelServices: 'Verifuel Services',
  Header_KeyPersonnel: 'Key Personnel',
  Header_OffSpec: 'Off Spec',
  Header_AverageALSI: 'Average AL + SI',
  Header_CylinderSearch: 'Cylinder Search',
  Header_CylinderDetails: 'Cylinder Details',
  Header_BVCylinderAVGDaysOut: 'BV Cylinder AVG Days Out',
  Header_CylinderLateFeesPending: 'Cylinder Late Fees Pending',
  Header_CylinderLateFeesBilledYTD: 'Cylinder Late Fees Billed YTD',
  Header_TotalRepairFeesYTD: 'Total Repair Fees ( YTD )',
  Header_ClientCylinderReturnTime: 'Client Cylinder Return Time',
  Header_SupplyCostSummary: 'Supply Cost Summary',
  Header_Role: 'Roles',
  Header_Permission: 'Permission',
  Header_AssignedPermissions: 'Assigned Permissions',
  Header_EditRole: 'Edit Role',
  Header_AddRole: 'Add Role',
  Header_OrderRequests: 'Order Request',
  Header_AddOrderRequest: 'Submit Order Request',
  Header_ContainerTypesReceived: 'Container Types Received',
  Header_SampleStatus: 'Sample Status',
  Header_SubmissionsBySampleType: 'Submissions by Sample Type',
  Header_SamplesByAnalysisType: 'Samples by Analysis Type',
  Header_Countries: 'Countries',
  Header_EditCountry: 'Edit Country',
  Header_Country: 'Country',

  Breadcrumb_Roles: 'Roles',
  Breadcrumb_Role: 'Role',
  Breadcrumb_Home: 'Home',
  Breadcrumb_Users: 'Users',
  Breadcrumb_News: 'News',
  Breadcrumb_ClientQuotes: 'Client Quotes',
  Breadcrumb_Submissions: 'Submissions',
  Breadcrumb_DataSchemas: 'Data Schemas',
  Breadcrumb_TranslationSets: 'Translation Sets',
  Breadcrumb_Targets: 'Targets',
  Breadcrumb_SampleTracking: 'Sample Tracking',
  Breadcrumb_Subscriptions: 'Subscriptions',
  Breadcrumb_AssetManagement: 'Asset Management',
  Breadcrumb_Document: 'Document',
  Breadcrumb_Documents: 'Documents',
  Breadcrumb_Invoices: 'Invoices',
  Breadcrumb_InvoiceDetails: 'Invoice Details',
  Breadcrumb_ObjectConfigurations: 'Object Configurations',
  Breadcrumb_InspectionLocations: 'Inspection Locations',
  Breadcrumb_TimeLogCalculation: 'Time Log Calculation',
  Breadcrumb_TimestampEvents: 'Timestamp Events',
  Breadcrumb_Countries: 'Countries',

  Label_GlobalFilterNote: 'Note: Global filters will only be applied to those screens where user access is defined. If screens will display empty data after global filter applied then please contact your Bureau Veritas Representative for further assistance.',
  Label_ScreenAccess: 'Screen Access',
  Label_Scenario: 'Scenario',
  Label_Phone: 'Phone',
  Label_Information: 'Information',
  Label_Chargeable: 'Chargeable',
  Label_CompanyName: 'Company Name',
  Label_VesselName: 'Vessel Name',
  Label_ImoNumber: 'IMO Number',
  Label_UserName: 'User Name',
  Label_Ordered: 'Status',
  Label_OrderDateFrom: 'Order Date From',
  Label_OrderDateTo: 'Order Date To',
  Label_LastUpdatedBy: 'Last Updated By',
  Label_AmendmentDateFrom: 'Amendment Date From',
  Label_AmendmentDateTo: 'Amendment Date To',
  Label_NumberOfKits: 'Number Of Kits',
  Label_AwbNumber: 'AWB Number',
  Label_DispatchDateFrom: 'Dispatch Date From',
  Label_DispatchDateTo: 'Dispatch Date To',
  Label_True: 'True',
  Label_BunkeringDateFrom: 'Bunkering Date From',
  Label_BunkeringDateTo: 'Bunkering Date To',
  Label_False: 'False',
  Label_City: 'City',
  Label_State: 'State',
  Label_Country: 'Country',
  Label_PostalCode: 'Postal Code',
  Label_LocationName: 'LocationName',
  Label_JobStatus: 'Job Status',
  Label_No_Widget: 'No Widget',
  Label_SampleName: 'Sample Name',
  Label_Analysis: 'Analysis',
  Label_SampleDescription: 'Sample Description',
  Label_BunkeringCountry: 'Bunkering Country',
  Label_FuelSupplier: 'Fuel Supplier',
  Label_ContractId: 'Contract Id',
  Label_FleetName: 'Fleet Name',
  Label_IMONumber: 'IMO Number',
  Label_SubmissionType: 'Submission Type',
  Label_ProductType: 'Product Type',
  Label_Grade: 'Grade',
  Label_SealNumber: 'Seal Number',
  Label_ArrivalDateAtLabTo: 'Arrival Date At Lab To',
  Label_ArrivalDateAtLabFrom: 'Arrival Date At Lab From',
  Label_StatusDateFrom: 'Status Date From',
  Label_StatusDateTo: 'Status Date To',
  Label_SampleSource: 'Sample Source',
  Label_SamplingDateFrom: 'Sampling Date From',
  Label_SamplingDateTo: 'Sampling Date To',
  Label_DateCreatedFrom: 'Date Created From',
  Label_DateCreatedTo: 'Date Created To',
  Label_ExpirationDate: 'Expiration Date',
  Label_SampleStatus: 'Sample Status',
  Label_Location: 'Location',
  Label_BVLocations: 'BV Locations',
  Label_Client: 'Client',
  Label_Clients: 'Clients',
  Label_Projects: 'Projects',
  Label_Project: 'Project',
  Label_ProjectSites: 'Project/Sites',
  Label_Name: 'Name',
  Label_NA: 'N/A',
  Label_Statistics: 'Statistics',
  Label_TargetDuration: 'Target Duration',
  Label_TimestampEvent1: 'Timestamp Event 1',
  Label_TimestampEvent2: 'Timestamp Event 2',
  Label_Job: 'Job',
  Label_ShipmentID: 'Shipment ID',
  Label_Sample: 'Sample',
  Label_AvgDays: 'Average Days',
  Label_Last3Months: 'Last 3 months',
  Label_Last12Months: 'Last 12 Months',
  Label_Jobs: 'Jobs',
  Label_Samples: 'Samples',
  Label_Orders: 'Orders',
  Label_Cylinders: 'Cylinders',
  Label_TurnaroundTime: 'Turnaround Time',
  Label_Received: 'Received',
  Label_PrepStarted: 'Prep Started',
  Label_InAnalysis: 'In Analysis',
  Label_Due: 'Due',
  Label_DueDate: 'Due Date',
  Label_AssignedTo: 'Assigned To',
  Label_ActionTitle: 'Action Title',
  Label_ActionType: 'Action Type',
  Label_ActionNumber: 'Action Number',
  Label_ActionsFor: 'Actions For',
  Label_ActionStatus: 'Action Status',
  Label_Reported: 'Reported',
  Label_Invoiced: 'Invoiced',
  Label_RoleName: 'Role Name',
  Label_Active: 'Active',
  Label_InActive: 'InActive',
  Label_Display: 'Display',
  Label_Title: 'Title',
  Label_Zone: 'Zone',
  Label_DocumentType: 'Document Type',
  Label_Roles: 'Roles',
  Label_Locations: 'Locations',
  Label_Division: 'Division',
  Label_Variant: 'Variant',
  Label_TestItems: 'Test Items',
  Label_AssignedLocations: 'Assigned Locations',
  Label_AssignedDivisions: 'Assigned Divisions',
  Label_SourceSystems: 'Source Systems',
  Label_sourceSystem: 'Source Systems',
  Label_SourceSystemId: 'Source Systems',
  Label_Description: 'Description',
  Label_Summary: 'Summary',
  Label_Details: 'Details',
  Label_User: 'User',
  Label_ImpersonateUser: 'Impersonate User',
  Label_Sort: 'Sort',
  Label_Direction: 'Direction',
  Label_FromAToZ: 'From A to Z',
  Label_FromZToA: 'From Z to A',
  Label_ReportName: 'Report Name',
  Label_JobNumber: 'Job Number',
  Label_DateGeneratedFrom: 'Date Generated From',
  Label_DateGeneratedTo: 'Date Generated To',
  Label_JobName: 'Job Name',
  Label_ReportType: 'Report Type',
  Label_Template: 'Template',
  Label_Subject: 'Subject',
  Label_Body: 'Body',
  Label_HTMLBody: 'HTML Body',
  Label_NotificationType: 'Notification Type',
  Label_EmailPlaceHolder: 'Email Placeholders',
  Label_Message: 'Message',
  Label_Permissions: 'Permissions',
  Label_Comments: 'Comments',
  Label_CreatedBy: 'Created By',
  Label_CreatedOn: 'Created On',

  Label_Rating: 'Rating',
  Label_Feedback: 'Feedback',
  Label_NewPassword: 'New Password',
  Label_ConfirmNewPassword: 'Confirm New Password',
  Label_CustomerAlert: 'Customer Alert',
  Label_GlobalFuelAlert: 'Global Fuel Alerts',
  Label_CustomerFuelAlert: 'Customer Fuel Alerts',
  Label_Sites: 'Site(s)',
  Label_From: 'From',
  Label_To: 'To',
  Label_FirstName: 'First Name',
  Label_LastName: 'Last Name',
  Label_Email: 'Email',
  Label_EmailAddress: 'Email Address',
  Label_DateFormat: 'Date Format',
  Label_DateTimeFormat: 'Date Time Format',
  Label_Timezone: 'Timezone',
  Label_Role: 'Role',
  Label_SearchUser: 'Search User',
  Label_Invoice: 'Invoice',
  Label_InvoiceNumber: 'Invoice Number',
  Label_InvoiceType: 'Type',
  Label_InvoiceDateFrom: 'Invoice Date From',
  Label_InvoiceDateTo: 'Invoice Date To',
  Label_CC: 'CC',
  Label_BCC: 'BCC',
  Label_DateReceivedFrom: 'Date Received From',
  Label_DateReceivedTo: 'Date Received To',
  Label_DateCompletedFrom: 'Date Completed From',
  Label_DateCompletedTo: 'Date Completed To',
  Label_RecentJobs: 'Recent Jobs',
  Label_LinkedJobs: 'Linked Jobs',
  Label_RecentSamples: 'Recent Samples',
  Label_Stretch: 'Stretch',
  Label_Compact: 'Compact',
  Label_ForgotPassword: 'Forgot Password',
  Label_SampleByStatus: 'Sample By Status',
  Label_Global_Fleet_Spec_Results: 'Global Fleet Spec Results',
  Label_Operational_Report: 'Operational Report',
  Label_Submission_Type_Tested: 'Submission Type Tested',
  Label_Product_Grades_Tested: 'Product Grades Tested',
  Label_Last30days: 'Last 30 days',
  Label_Last180days: 'Last 180 days',
  Label_YTD: 'YTD',
  Label_SpecResult: 'Spec Result',
  Label_QuoteNumber: 'Quote Number',
  Label_AttachedFile: 'Attached File',
  Label_Supplier: 'Supplier',
  Label_QuotationInfo: 'Quotation Info',
  Label_Attachments: 'Attachments',
  Label_Laboratory: 'Laboratory',
  Label_ContractNumber: 'Contract Number',
  Label_ContractList: 'Contract List',
  Label_StartDate: 'Start Date',
  Label_EndDate: 'End Date',
  Label_DateFrom: 'Date From',
  Label_DateTo: 'Date To',
  Label_SchemaName: 'Schema Name',
  Label_SchemaType: 'Schema Type',
  Label_SourceSystem: 'Source System',
  Label_DataSourceType: 'Data Source Type',
  Label_ContentType: 'Content Type',
  Label_SampleLocation: 'Sample Location',
  Label_SubscriptionName: 'Subscription Name',
  Label_Target: 'Target',
  Label_TargetDetail: 'Target Detail',
  Label_EventTrigger: 'Event Trigger',
  Label_General: 'General',
  Label_TranslationSet: 'Translation Set',
  Label_ClientOrderNumber: 'Client Order Number',
  Label_ClientQuotation: 'Client Quotation',
  Label_DispatchDate: 'Dispatch Date',
  Label_TransportCompany: 'Transport Company',
  Label_ConsignmentNumber: 'Consignment Number',
  Label_DispatchedIn: 'Dispatched In',
  Label_ProjectNumber: 'Project Number',
  Label_SampleIdentityNumber: 'Sample Identity Number',
  Label_SampleID: 'Sample ID',
  Label_CourierDateFrom: 'Courier Date From',
  Label_CourierDateTo: 'Courier Date To',
  Label_CourierStatus: 'Courier Status',
  Label_HazardsMaterial: 'Hazards Material',
  Label_HazardOther: 'Hazard Other',
  Label_TurnAroundTime: 'Turnaround Time',
  Label_SamplePreperation: 'Sample Preparation',
  Label_SampleMatrix: 'Sample Matrix',
  Label_CountryOfOrigin: 'Country Of Origin',
  Label_Priority: 'Priority',
  Label_Trending: 'Trending',
  Label_Filters: 'Filters',
  Label_GlobalFilter: 'Global Filter',
  Label_ChartTypes: 'Chart Types',
  Label_Custom: 'Custom',
  Label_TargetName: 'Target Name',
  Label_MessageMappping: 'Message Mapping',
  Label_ItemSetting: 'Item Setting',
  Label_Output: 'Output',
  Label_Markers: 'Markers',
  Label_NewRow: 'New Row',
  Label_Label: 'Label',
  Label_Value: 'Value',
  Label_DataType: 'Data Type',
  Label_Type: 'Type',
  Label_Operator: 'Operator',
  Label_Required: 'Required',
  Label_Translatable: 'Translatable',
  Label_TriggerTemplate: 'Trigger Template',
  Label_MatchingCondition: 'Matching Condition',
  Label_TranslationKey: 'Translation Key',
  Label_DataSchema: 'Data Schema',
  Label_TranslationSetName: 'Translation Set Name',
  Label_Field: 'Field',
  Label_Table: 'Table',
  Label_Condition: 'Condition',
  Label_TemplateCondition: 'Template Condition',
  Label_Method: 'Method',
  Label_Path: 'Path',
  Label_ProcessStatus: 'Process Status',
  Label_Error: 'Error',
  Label_DispatchStatus: 'Dispatch Status',
  Label_Response: 'Response',
  Label_Host: 'Host',
  Label_APIPath: 'API Path',
  Label_Encoding: 'Encoding',
  Label_AuthenticationSchema: 'Authentication Schema',
  Label_HttpMethod: 'Http Method',
  Label_BearerToken: 'Bearer Token',
  Label_WebAPI: 'WebAPI',
  Label_MessageType: 'Message Type',
  Label_Headers: 'Headers',
  Label_ShowHideTree: 'Show/Hide Tree',
  Label_SerialNo: 'SerialNo',
  Label_EquipmentName: 'Equipment Name',
  Label_EquipmentNo: 'Equipment No',
  Label_Site: 'Site',
  Label_Model: 'Model',
  Label_Manufacturer: 'Manufacturer',
  Label_ClientInformation: 'Client Information',
  Label_QuickFilter: 'Quick Filter',
  Label_DateCreated: 'Date Created',
  Label_DateReceived: 'Date Received',
  Label_Default: 'Default',
  Label_RowsPerPage: 'Rows per page:',
  Label_ShowHideFilers: 'Show/Hide Filters',
  Label_NewActionFor: 'New action for',
  Label_ShowingNEquipments: 'Showing {{n}} Equipments(s)',
  Label_ShowHideOutput: 'Show/Hide Output',
  Label_ReportedOn: 'Reported On',
  Label_ReportReprint: 'Report Reprint',
  Label_Approved: 'Approved',
  Label_OrderNumber: 'Order Number',
  Label_requester: 'Requested By',
  Label_requesterIDs: 'Requested By',
  Label_LocationType: 'Location Type',
  Label_ExportData: 'Export Data',
  Label_GroupName: 'Group Name',
  Label_IsTemplate: 'Is Template',
  Label_Recipients: 'Recipients',
  Label_EnterEmail: 'Enter Email',
  Label_UserType: 'User Type',
  Label_ObjectType: 'Object Type',
  Label_Configs: 'Configs',
  Label_OutboundID: 'Outbound ID',
  Label_Status: 'Status',
  Label_StatusId: 'Status',
  Label_ProcessedOn: 'Processed On',
  Label_SourceSystemResponse: 'SourceSystem Response',
  Label_OutboundDetail: 'Outbound Detail',
  Label_JobDescription: 'Job Description',
  Label_ProductGrade: 'Product Grade',
  Label_SampleNumber: 'Sample Number',
  Label_NoTransformationNeeded: 'No Transformation Needed',
  Label_ClientName: 'Client Name',
  Label_SpecialInstruction: 'Special Instruction',
  Label_Latitude: 'Latitude',
  Label_Longitude: 'Longitude',
  Label_DefaultTimeZone: 'Default Time Zone',
  Label_clientName: 'Client Name',
  Label_active: 'Active',
  Label_client: 'Client',
  Label_recordId: 'Record ID',
  Label_objectType: 'Object Type',
  Label_locationName: 'Location Name',
  Label_type: 'Type',
  Label_country: 'Country',
  Label_city: 'City',
  Label_state: 'State',
  Label_postalCode: 'Postal Code',
  Label_UserGroupName: 'Group Name',
  Label_TimeStamp: 'Timestamp Event',
  Label_Tag: 'Tag',
  Label_EventName: 'Event Name',
  Label_Category: 'Category',
  Label_SentToCustomerPortal: 'Sent To Customer Portal',
  Label_CaptureEstimatedDate: 'Capture Estimated Date',
  Label_Permission_Name_is_required: 'Permission Name is required',
  Label_Permission_Code_is_required: 'Permission Code is required',
  Label_Title_is_required: 'Title is required',
  Label_Max_length_n: 'Max length is {{n}}',
  Label_Document_Type_is_required: 'Document Type is required',
  Label_Division_is_required: 'Division is required',
  Label_Description_is_required: 'Description is required',
  Label_File_is_required: 'File is required',
  Label_Load_document_failed: 'Load document failed',
  Label_SubmissionID: 'Submission ID',
  Label_CreatedOnTo: 'Created On To',
  Label_CreatedOnFrom: 'Created On From',
  Label_ReportAddress: 'Report Address',
  Label_PONumber: 'PO Number',
  // export start page
  Label_BunkerResults: 'Bunker Results',
  Label_FuelSystemsReport: 'Fuel Systems Report',
  Label_ContractDetails: 'Contract Details',
  Label_InternalReport: 'Internal Report',
  Label_WorldFleetStatistics: 'World Fleet Statistics',
  Label_Contract: 'Contract',
  Label_BunkeringStartDate: 'Bunkering Start Date',
  Label_BunkeringEndDate: 'Bunkering End Date',
  Label_BunkeringDateRange: 'Bunkering Date Range',
  // export page end

  Label_RecipientContactName: 'Recipient Contact Name',
  Label_RecipientEmail: 'Recipient Email',
  Label_RecipientPhone: 'Recipient Phone',
  Label_AddressLine1: 'Address Line 1',
  Label_AddressLine2: 'Address Line 2',
  Label_AddressLine3: 'Address Line 3',
  Label_AssociatedFleet: 'Associated Fleet',
  Label_AssociatedVessel: 'Associated Vessel',
  Label_PurchaseOrder: 'Purchase Order',
  Label_PurchaseOrderAttach: 'Purchase Order Attach',
  Label_ServiceProvider: 'Service Provider',
  Label_TrackingLink: 'Tracking Link',
  Label_DestinationLab: 'Destination Lab',
  Label_BunkeringPort: 'Bunkering Port',
  Label_SampleDetails: 'Sample Details',
  Label_No_Data: 'No Data',
  Label_SampleCategory: 'Sample Category',
  Label_SampleType: 'Sample Type',

  Label_CylinderID: 'Cylinder Id',
  Label_CylinderType: 'Cylinder Type',
  Label_Requestor: 'Requestor',
  Label_LateStatus: 'Last Status',
  Label_DaysOut: 'Days Out',
  Label_RentalAgreementNumber: 'Rental Agreement Number',
  Label_ShippedDateFrom: 'Shipped Date From',
  Label_ShippedDateTo: 'Shipped Date To',
  Label_ReturnDueDateFrom: 'Return Due Date From',
  Label_ReturnDueDateTo: 'Return Due Date To',
  Label_AirWaybillNumber: 'Air Waybill Number',
  Label_CourierShipmentDateFrom: 'Courier Shipment Date From',
  Label_CourierShipmentDateTo: 'Courier Shipment Date To',
  Label_SubStatus: 'Sub Status',
  Label_scenarioIDs: 'Scenarios',

  Label_OrderedBy: 'Ordered By',
  Label_InvoiceClient: 'Invoice Client',
  Label_Rush: 'Rush',
  Label_ShiptoClient: 'Ship to Client',
  Label_ShipCity: 'Ship  to City',
  Label_dueDateFrom: 'Ship Due Date From',
  Label_dueDateTo: 'Ship Due Date To',
  Label_orderDateFrom: 'Order Date From',
  Label_orderDateTo: 'Order Date To',
  Label_supplyTypes: 'Order Items',
  Label_orderRequestID: 'Order Request ID',
  Label_SupplyType: 'Supply Type',
  Label_orderName: 'Order Name',
  Label_orderRequestedBy: 'Order Requested By',
  Label_isRecurring: 'Is Recurring',
  Label_RushOrder: 'Rush Order',
  Label_ClientID: 'Clients',
  Label_ClientIDPetro: 'Client ID',
  Label_StatusID: 'Status',
  Label_DueDateFrom: 'Order Due Date From',
  Label_DueDateTo: 'Order Due Date To',
  Label_flags: 'Is Template',
  Label_ShortName: 'Short Name',
  Label_supplyTypeIDs: 'Supply Type',
  Label_SourceSystemRecordID: 'Client No',
  Label_vsLastMonth: 'vs last month',
  Label_vsLastYear: 'vs last year',
  Label_BVCylindersByState: 'Cylinders By State',
  Label_BVCylindersByType: 'Cylinders By Type',
  Label_RentalFeesByClient: 'Fees By Client#',
  Label_ThisMonth: 'This Month',
  Label_ThisQuarter: 'This Quarter',
  Label_CylinderActivityByClient: 'Rental Cylinder Activity by Client#',
  Label_CylinderActivityByRequestor: 'Rental Cylinder Activity by Requestor',
  Label_CumulativeFeesByClient: 'Cumulative Fees by Client#',
  Label_ClientCylindersByStatus: 'Client Cylinders By Status',
  Label_BV_Rental: 'BV Rental',
  Label_Client_Owned: 'Client Owned',
  Label_RecentOrders: 'Recent Orders',
  Label_OrdersByStatus: 'Orders By Status',
  Label_OrdersByShipLocation: 'Orders By Ship Location',
  Label_KPICard: 'KPI CARD',
  Label_RepairFeesCalendarYTD: 'Repair Fees (Calendar YTD)',
  Label_AverageReturnTime: 'Average Return Time (Days) : ',
  Label_DelayedReturns: 'Delayed Returns (Days) : ',
  Label_orderNumber: 'Order Number',
  Label_statusIDs: 'Status',
  Label_requestor: 'Ordered By',
  Label_rushOrder: 'Rush Order',
  Label_clientIDs: 'Clients',
  Label_reportAddressIDs: 'Report Address',
  Label_invoiceAddressIDs: 'Invoice Address',
  Label_shipToCompany: 'Ship To Company',
  Label_shipToFacility: 'Ship To Facility',
  Label_companyName: 'Ship Facility',
  Label_templateNo: 'Template',
  Label_OrderDueDateFrom: 'Order Due Date From',
  Label_ClientIDs: 'Clients',
  Label_cylinderIDs: 'Cylinder ID',
  Label_CountryName: 'Country Name',
  Label_CountryInformation: 'Country Information',
  Label_CountryCode: 'Country Code',
  Label_CountryCode2: 'Country Code 2',
  Label_CountryCodeNumber: 'Country Code Number',
  Label_CountryDataDoesNotExist: 'Country data does not exist',
  Label_CustomFields: 'Custom Fields',
  Label_UpdatedBy: 'Updated By',
  Label_UpdatedOn: 'Updated On',
  Label_LocationIdentifier: 'Location Identifier',
  Label_LocationFormat: 'Location Format',
  Label_MaxxID: 'Maxx ID',
  Label_sampleClientIDS: ' Client ID',
  Label_AnalysisType: 'Analysis Type',
  Label_MaxxAlertStatus: 'MaxxAlert Status',
  Label_AttentionName: 'Attention Name',
  Label_SampleDateFrom: 'Sample Date From',
  Label_SampleDateTo: 'Sample Date To',
  Label_ReceivedDateFrom: 'Received Date From',
  Label_ReceivedDateTo: 'Received Date To',
  Label_SamplePoint: 'Sample Point',
  Label_Area: 'Field/Area',
  Label_ClientReviewStatus: 'Client Review Status',
  Label_Matrix: 'Matrix',
  Label_SamplingPoint: 'Sampling Point',
  Label_Fraction: 'Measurement Unit',
  Label_Parameter: 'Parameter',
  Label_SampleDetailsNote: 'Statistics available when >4 data points exist and based on the most recent 24 samples.',
  Label_SampleDetailsNote2: '* - Variance/Standard Deviation >= 2.0',
  Label_SampleDetailsNote3: '** - Variance/Standard Deviation >= 3.0',
  Label_MaxxId: 'Maxx ID',
  Label_ParameterNames: 'Parameters',

  Button_Save: 'Save',
  Button_Save_As_Template: 'Save As Template',
  Button_SaveFilter: 'Save Filter',
  Button_SavedFilter: 'Saved Filter',
  Button_Submit: 'Submit',
  Button_Update: 'Update',
  Button_Test: 'Test',
  Btn_ShowFilter: 'Show Filter',
  Btn_HideFilter: 'Hide Filter',
  Btn_Download: 'Download',
  Button_Back: 'Back',
  Button_Delete: 'Delete',
  Button_ChooseFile: 'Choose File',
  Button_Cancel: 'Cancel',
  Button_UpdateOrder: 'Update Order',
  Button_CreateOrder: 'Create Order',
  Button_CancelOrder: 'Cancel Order',
  Text_NoPostCode: 'NA if no postal code',
  Text_NoState: 'NA if no state',
  Text_Add: 'Add',
  Header_AddConsumables: 'Add New',
  Btn_Confirm: 'Confirm',
  Btn_Reject: 'Reject',
  Btn_ClearClientStatus: 'Clear Client Status',
  Btn_ReadMore: '...Read More',
  Btn_ReadLess: 'Read Less',
  Btn_Login: 'Login',
  Btn_Apply: 'Apply',
  Btn_Reset: 'Reset',
  Btn_ClearFilters: 'Clear Filters',
  Btn_ClearFilter: 'Clear Filter',
  Btn_SaveFilter: 'Save Filter',
  Btn_ApplyFilter: 'Apply Filter',
  Btn_ClearAll: 'Clear All',
  Btn_ManageDisplay: 'Manage Display',
  Btn_StopImpersonating: 'Stop Impersonating',
  Btn_Logout: 'Log Out',
  Btn_Add: 'Add',
  Btn_Cancel: 'Cancel',
  Btn_Yes: 'Yes',
  Btn_No: 'No',
  Btn_Upload: 'Upload',
  Btn_NewDocument: 'Document',
  Btn_AddNews: 'News',
  Btn_Submit: 'Submit',
  Btn_Settings: 'Settings',
  Btn_Profile: 'Profile',
  Btn_ManageFilters: 'Manage Filters',
  Btn_Clear: 'Clear',
  Btn_Save: 'Save',
  Btn_PlaceHolders: 'PlaceHolders',
  Btn_AddRole: 'Role',
  Btn_AddActions: 'New Action',
  Btn_EditNotifications: 'Notifications',
  Btn_Export: 'Export',
  Btn_Close: 'Close',
  Btn_Edit: 'Edit',
  Btn_Feedback: 'Feedback',
  Btn_Preview: 'Preview',
  Btn_ChangeMyPassword: 'Change my password',
  Btn_ManageDate: 'Manage Date',
  Btn_ViewUser: 'View User',
  Btn_Next: 'Next',
  Btn_Previous: 'Previous',
  Btn_Complete: 'Complete',
  Btn_LinkMore: '... more',
  Btn_Refresh: 'Refresh',
  Btn_SaveOrder: 'Save Order',
  Btn_Create_Request: 'Create Request',
  Btn_AddNew: 'Add New',
  Btn_Submission: 'Submission',
  Btn_Start: 'Start',
  Btn_ReOpen: 'Re-open',
  Btn_Comment: 'Comment',
  Btn_ShowMoreComments: 'More',
  Btn_StartAction: 'Start Action',
  Btn_NewAction: 'New Action',
  Btn_Load5MoreLastCompletedActions: 'Load 5 more last completed actions',
  Btn_HideOutput: 'Hide Output',
  Btn_ShowOutput: 'Show Output',
  Btn_MapAndList: 'Map & List',
  Btn_MapOnly: 'Map Only',
  Btn_ListOnly: 'List Only',
  Btn_Create: 'Create',
  Btn_Beautify: 'Beautify',
  Btn_Minify: 'Minify',
  Btn_Generate: 'Generate',
  Btn_ShowAll: 'Show All',
  Btn_Print: 'Print',
  Column_DateAdded: 'Date Added/Uploaded',
  Column_Download: 'Download',
  Column_Action: 'Action',
  column_DocumentTypeName: 'Document Type',
  Column_JobNumber: 'Job Number',
  Column_Title: 'Title',
  Column_Filename: 'Filename',
  Column_GeneratedOn: 'Generated On',
  Column_Date: 'Date',
  Column_Headline: 'Headline',
  Column_Select: 'Select',
  Column_FirstName: 'First Name',
  Column_LastName: 'Last Name',
  Column_EmailAddress: 'Email Address',
  Column_UpdatedOn: 'Updated On',
  Column_Category: 'Category',
  Column_Severity: 'Severity',
  Column_Sample_Date: 'Sample Date',
  Column_Component_Age: 'Component Age',
  Column_Lube_Age: 'Lube Age',
  Column_Filter_Changed: 'Filter Changed',
  Column_Product: 'Product',
  Column_Website: 'Website',
  Column_Sample_Number: 'Sample_Number',
  Column_ProductName: 'Product',
  Column_ParcelName: 'Parcel',
  Column_Relationship: 'Relation',
  Column_IR: 'IR',
  Column_CR: 'CR',
  Column_NI: 'NI',
  Column_AL: 'AL',
  Column_LD: 'LD',
  Column_CO: 'CO',
  Column_TI: 'TI',
  Column_SI1: 'SI',
  Column_TT: 'TT',
  Column_VA: 'VA',
  Column_SI2: 'SI',
  Column_ModelID: 'Model',
  Column_AssetNumber: 'Asset Number',
  Column_Component: 'Component',
  Column_Manufacturer: 'Manufacturer',
  Column_Model: 'Model',
  Column_Serial: 'Serial',
  Column_Name: 'Name',
  Column_TimeLogCalcDisplayName: 'Name',
  Column_TimeLogEventName1: 'Start',
  Column_TimeLogEventName2: 'End',
  Column_Duration: 'Result (Duration)',
  Column_AssetNo: 'Asset No',
  Column_SerialNo: 'Serial No',
  Column_CreatedOn: 'Created On',
  Column_Client: 'Client',
  Column_ContractNumber: 'Contract Number',
  Column_JobName: 'Job Name',
  Column_JobStatusName: 'Job Status Name',
  Column_JobDescription: 'Job Description',
  Column_ClientReference: 'Client Reference',
  Column_JobStartDate: 'Job Start Date',
  Column_JobCoordinator: 'Job Coordinator',
  Column_JobDateReceived: 'Job Date Received',
  Column_InvoiceNumber: 'InvoiceNumber',
  Column_Type: 'Type',
  Column_Amount: 'Amount',
  Column_InvoiceDate: 'Invoice Date',
  Column_PaymentDueDate: 'Payment Due Date',
  'Column_Sample Details': 'Sample Details',
  Column_LineItemDescription: 'Description',
  Column_Unit: 'Unit',
  Column_Currency: 'Currency',
  Column_Quantity: 'Quantity',
  'Column_Unit Price': 'Unit Price',
  Column_VAT: 'TAX',
  Column_TotalWithTax: 'Total (with Tax)',
  Column_TotalWithoutTax: 'Total (without Tax)',
  Column_JobCompletionDate: 'Job Completion Date',
  Column_StatusName: 'Status Name',
  Column_DateReceived: 'Date Received',
  Column_AnalysticalStartDate: 'Analytical Start Date',
  Column_AnalyticalStartDate: 'Analytical Start Date',
  Column_FirstDateFinished: 'First Date Finished',
  Column_SampleCount: 'Sample Count',
  Column_FirstSampleNumber: 'First Sample Number',
  Column_LastSampleNumber: 'Last Sample Number',
  Column_SampleTypeName: 'Sample Type Name',
  Column_ClientNames: 'Client Names',
  Column_ClientOrderNo: 'Client Order No',
  Column_HasCOA: 'Has COA',
  Column_SampleName: 'Sample Name',
  Column_Selection: 'Selection',
  Column_ClientSampleNo: 'Client Sample No',
  Column_SampleSequence: 'Sample Sequence',
  Column_LocationName: 'Location Name',
  Column_ReceivedOn: 'Received On',
  Column_SamplingDate: 'Sampling Date',
  Column_BatchLotRef: 'Batch Lot Ref',
  Column_AnalysisStartDate: 'Analysis Start Date',
  Column_AnalysisCompleteDate: 'Analysis Complete Date',
  Column_ClientSampleRef: 'Client Sample Ref',
  Column_FilterAge: 'Filter Age',
  Column_TimeSinceFilterChange: 'Time Since Filter Change',
  Column_OwnerName: 'Owner Name',
  Column_ActionTypeName: 'Action Type Name',
  Column_DueDate: 'Due Date',
  Column_BelongsTo: 'Belongs To',
  Column_ObjectName: 'Object Name',
  Column_CreatedByName: 'Created By Name',
  Column_AcceptedOn: 'Accepted On',
  Column_AcceptedByName: 'Accepted By Name',
  Column_CompletedOn: 'Completed On',
  Column_CompletedByName: 'Completed By Name',
  Column_ParameterName: 'Parameter Name',
  Column_SpecName: 'Spec Name',
  Column_ResultValue: 'Result Value',
  Column_ResultUniName: 'Result Unit Name',
  Column_SiteName: 'Site Name',
  Column_SampleDescription: 'Sample Description',
  Column_SubmissionID: 'Submission ID',
  Column_SubmittedBy: 'Submitted By',
  Column_SubmittedOn: 'Submitted On',
  Column_InboundID: 'Inbound ID',
  Column_ProcessedOn: 'Processed On',
  Column_ExtSystemCode: 'Ext System Code',
  Column_Object: 'Object',
  Column_Record: 'Record',
  Column_Comment: 'Comment',
  Column_Rating: 'Rating',
  'Column_Created On': 'Created On',
  'Column_Created By': 'Created By',
  Column_Username: 'Username',
  Column_ReportType: 'Report Type',
  Column_Project: 'Project',
  Column_Brand: 'Brand',
  Column_Description: 'Description',
  Column_TimeLogCalculationDescription: 'Description',
  Column_Source: 'Source',
  Column_Supplier: 'Supplier',
  Column_SampleLocation: 'Sample Location',
  Column_ProcedureCode: 'Procedure Code',
  Column_Samples: 'Samples',
  Column_CodeDescription: 'Code Description',
  Column_Result: 'Result (duration)',
  Label_Start: 'Start',
  Label_End: 'End',
  Parcel: 'Parcel',
  Column_Status: 'Status',
  Column_Lab: 'Lab',
  Column_BatchSampleCount: 'Batched',
  Column_BatchSampleValidatedCount: 'Batch Validated',
  Column_CheckedSampleCount: 'ReWeigh/Check',
  Column_ClientOrderNumber: 'Client Order Number',
  Column_AssetName: 'Asset Name',
  Column_ClientName: 'Client Name',
  Column_ManufacturerName: 'Manufacturer Name',
  Column_SampledDate: 'Sampled Date',
  Column_DocumentID: 'Document ID',
  Column_CreatedBy: 'Created By',
  InEx: 'In/Ex',
  Column_Calculation: 'Calculation',
  Column_Dry_Weight: 'Dry Weight (DMT)',
  Column_Moisture: 'Moisture',
  Column_Wet_Weight: 'Wet Weight (WMT)',
  Column_JobParcelID: 'Parcel',
  Column_Comments: 'Comments',
  Column_TaxAmount: 'Tax Amount',
  Column_Price: 'Price',
  Column_VefFactor: 'VEF Factor',
  Column_UserGroupName: 'Name',
  Column_RoleName: 'Role Name',
  Column_UserType: 'User Type',
  Column_LastLogin: 'Last Login',
  Column_Salutation: 'Salutation',
  Column_ObjectConfigurationID: 'ID',
  Column_ObjectType: 'Object Type',
  Column_RecordID: 'Record ID',
  Column_LastUpdatedOn: 'Updated On',
  Column_LastUpdatedBy: 'Updated By',
  'Column_Last Downloaded On': 'Downloaded On',
  'Column_Last Downloaded By': 'Downloaded By',
  Column_OutboundID: 'Outbound ID',
  Column_SourceSystemResponse: 'SourceSystem Response',
  Column_SampleNumber: 'Sample Number',
  Column_ExpectedDate: 'Expected Date',
  Column_TargetDate: 'Target Date',
  Column_Report: 'Report',
  Column_PostalCode: 'Postal Code',
  Column_ResultUnit: 'Result Unit',
  Column_OrderNo: 'Order Number',
  Column_CompanyName: 'Company Name',
  Column_VesselName: 'Vessel Name',
  Column_ImoNumber: 'IMO Number',
  Column_UserName: 'User Name',
  Column_OrderDate: 'Order Date',
  Column_NumberOfKits: 'Number Of Kits',
  Column_AWBNumber: 'AWB Number',
  Column_DateDispatch: 'Date Dispatch',
  Column_DeliveryAddress: 'Delivery Address',
  Column_StatusDate: 'Status Date',
  Column_ArrivedDate: 'Arrived Date In Lab',
  Column_SealNo: 'Seal No',
  Column_ProductType: 'Product Type',
  Column_ISOGrade: 'ISO Grade',
  Column_BunkerPort: 'Bunker Port',
  Column_BunkerDate: 'Bunker Date',
  Column_VeriFuelID: 'VeriFuel ID',
  Column_NoOfItems: 'No. of Items',
  Column_SpecsRequired: 'Specs Required',
  Column_SealRange: 'Seal Range',
  Column_SpecComparison: 'Spec Comparison',
  Column_CylinderID: 'Cylinder ID',
  Column_CylinderType: 'Cylinder Type',
  Column_Requestor: 'Requestor',
  Column_OrderNumber: 'Order Number',
  Column_RentalAgreementNumber: 'Rental Agreement Number',
  Column_ShipToLocation: 'Ship To Location',
  Column_ShippedDate: 'Shipped Date',
  Column_ReceivedDate: 'Received Date',
  Column_ExpectedDeliveryDate: 'Expected Delivery Date',
  Column_DeliveredDate: 'Delivered Date',
  Column_ReturnedDate: 'Returned Date',
  Column_DaysOut: 'Days Out',
  Column_GracePeriodEndDate: 'Grace Period End Date',
  Column_RentalFees: 'Rental Fees',
  Column_WayBillNumber: 'Way Bill Number',
  Column_SubStatus: 'Sub Status',
  Column_ReportAddress: 'Report Address',
  Column_RentalFeesOutstanding: 'Rental Fees (Outstanding)',
  Column_RentalFeesBilled: 'Rental Fees (Billed)',

  Toast_UpdatedSuccessfully: 'Updated Successfully',
  Toast_Add_new_document_successfully: 'Add new document successfully',
  Toast_Add_document_failed: 'Add document failed',
  Toast_Create_document_failed: 'Create document failed',
  Toast_UpdateFailed: 'Update Failed',
  Toast_CreatedSuccessfully: 'Created Successfully',
  Toast_SelectedSuccessfully: 'Selected Successfully',
  Toast_SavedSuccessfully: 'Save sucessfully!',
  Toast_ColumnDisplayUpdatedSuccessfully: 'Column Display updated successfully!',
  Toast_ColumnDisplayUpdateFailed: 'Column Display update failed!',
  Toast_ColumnsCannotBeRetrieved: 'Columns cannot be retrieved!',
  Toast_UnableToSaveFilter: 'Unable to save filter preset!',
  Toast_FilterDisplayUpdatedSuccessfully: 'Filter Display updated successfully!',
  Toast_FilterDisplayUpdateFailed: 'Filter Display update failed!',
  Toast_ConfiguredFieldsCannotBeRetrieved: 'Configured fields cannot be retrieved!',
  Toast_ActionStatusUpdatedSuccessfully: 'Action status updated successfully!',
  Toast_FilesUploadedSuccessfully: 'File(s) uploaded successfully',
  Toast_FileRemovedSuccessfully: 'File removed successfully',
  Toast_FileDownloadedSuccessfully: 'File downloaded successfully!',
  Toast_ActionAddedSuccessfully: 'Action added successfully!',
  Toast_UserCreatedSuccessfully: 'An email will be sent out shortly to your provided email address, please check that in your email Inbox including spam/junk folders.',
  Toast_ErrorFetchingSampleInfo: 'Sample Info cannot be retrieved!',
  Toast_ClientUserCreatedSuccessfully: 'Client user created successfully!',
  Toast_ClientAccessValidationError: 'Please enter Client and Screen Access.',
  Toast_RoleIsRequired: 'Role is required',
  Toast_AddressValidationError: 'Please enter all mandatory fields in Address Info section.',

  Error_DescriptionRequired: 'Description is required',
  Error_RoleIsRequired: 'Role is required',
  Error_SelectRoleFirst: 'Please select role first',
  Error_FirstLineIsRequired: 'AddressLine1 is required',
  Error_SecondLineIsRequired: 'AddressLine2 is required',
  Error_ThirdLineIsRequired: 'AddressLine3 is required',
  Error_Message_NoDataFound: 'No Data Found',
  Error_LoadingError: 'Loading error',
  Error_Message_NoColumnsFound: 'No columns found!',
  Error_NoItemsFound: 'No items found!',
  Error_NoPresetFound: 'No preset found!',
  Error_DateRangeCannotExceed3Months: 'Date range cannot exceed 3 months, please try a different range.',
  Error_ReportGenerationFailed: 'Report generation failed, please try again later.',

  Info_Rush_service_Charges: 'Rush service charges',
  Info_Rush_Message: 'Rush service can not be guaranteed - Please contact laboratory directly to confirm additional charges will apply',
  Info_RecoveryPasswordEmailHasBeenSent: 'Recovery password email has been sent',

  Confirm_UpdateRole: 'Update Role: ',
  Confirm_Message_UpdateRole: 'Are you sure you want to update this role?',
  Confirm_DeleteRole: 'Delete Role: ',
  Confirm_Message_Delete: 'Are you sure you want to delete this record?',
  Confirm_Message_DeleteTemplate:
    'Are you sure you want to delete this template?',
  Confirm_Title_ArchiveDocument: 'Archive document: ',
  Confirm_Message_ArchiveDocument:
    'Are you sure you want to archive this document?',
  Confirm_Title_UnarchiveDocument: 'Unarchive document: ',
  Confirm_Message_UnarchiveDocument:
    'Are you sure you want to unarchive this document?',
  Confirm_Title_ConfirmDelete: 'Confirm Delete',
  Info_Message_ExportSuccess: 'Export data successfully',
  Error_ActionTypeRequired: 'Action Type is required',
  Error_AssignedToRequired: 'Assigned To is required',
  Error_TitleRequired: 'Title is required',
  Error_DueDateRequired: 'Due Date is required',
  Error_LaboratoryIsRequired: 'Laboratory Is Required',
  Error_DispatchDateIsRequired: 'Dispatch Date Is Required',
  Error_TurnAroundTimeIsRequired: 'Turn Around Time Is Required',
  Error_HazardsMaterialIsRequired: 'Hazards Material Is Required',
  Error_DispatchedInIsRequired: 'Dispatched In Is Required',
  Error_Message_ExportSuccess: 'Error to export data',
  Info_Message_SaveSuccessfully: 'Save Successfully',
  Error_Message_SaveError: 'Save Failed',
  Info_Message_DownloadSuccess: 'Download Successfully',
  Error_Message_DownloadError: 'Download Failed',
  Info_Message_DeleteSuccess: 'Delete Successfully',
  Error_Message_DeleteError: 'Delete Failed',
  Error_Message_ChangePasswordError: 'Change Password Failed',
  Info_Message_UpdateUserSuccess: 'Update User Successfully',
  Error_Message_UpdateUserError: 'Update User Failed',
  Error_Message_LoadUserError: 'Load User Failed',
  Error_ClientIsRequired: 'Client is Required',
  Error_SupplierIsRequired: 'Supplier is Required',
  Error_LocationIsRequired: 'Location is Required',
  Error_SourceSystemIsRequired: 'Source System is Required',
  Error_DataSourceTypeIsRequired: 'Data Source Type is Required',
  Error_ContentTypeIsRequired: 'Content Type is Required',
  Error_ObjectTypeIsRequired: 'Object Type is Required',
  Info_Message_NoGlobalFilterToApply: 'Client is mandatory to apply global filter',
  Info_Message_DownloadReportsSuccess: 'Reports downloaded successfully!',
  Info_Message_DownloadInvoicesSuccess: 'Invoices downloaded successfully!',
  Error_Message_SomethingWentWrong: 'Something went wrong!',
  Error_TemplateNameIsRequired: 'Template Name is Required',
  Error_LoadingDataError: 'Loading Data Error',
  Created_Submission_Successfully: 'Created Submission Successfully',
  Error_TargetNameIsRequired: 'Target Name is required',
  Error_PleaseAddAtLeastOneProduct: 'Please add at least one product',
  Error_PleaseSelectProductForAllRows: 'Please select a product for all rows',
  Error_PleaseEnterNumberOfItems: 'Please enter number of items for',
  Error_MaximumItemsAllowed: 'Maximum items allowed',
  Error_SpecificationsRequired: 'Specifications required for',
  Error_ProductAlreadyAdded: 'is already added. Please select a different product',
  Error_DivisionIsRequired: 'Division is required',
  Toast_Quantity_Display_Group_Deleted: 'Quantity Display Group Deleted',
  Info_Message_MessageMappingModes: 'Message Mapping Modes',
  Error_TranslationSetNameIsRequired: 'Translation Set Name is Required',
  Error_BelongsToIsRequired: 'BelongsTo is Required',
  Error_RecordIDIsRequired: 'RecordID is Required',
  Error_EventTriggerIsRequired: 'Event Trigger is required',
  Error_TemplateIsRequired: 'Template is required',
  Error_TargetDetailIsRequired: 'Target Detail is required',
  Error_WebApiIsRequired: 'Web Api is required',
  Error_BearerTokenIsRequired: 'Bearer Token is required',
  Error_PostIsRequired: 'Post is required',
  Error_HostNameIsRequired: 'Host Name is required',
  Error_APIPathIsRequired: 'API Path is required',
  Error_EncodingIsRequired: 'Encoding is required',
  Error_NameIsRequired: 'Name is required',
  Error_DateFromRequired: 'Date From is required',
  Error_DateToRequired: 'Date To is required',
  Error_TypeIsRequired: 'Type is required',
  Error_CountryIsRequired: 'Country is required',
  Error_PostCodeIsRequired: 'Post Code is required',
  Error_TimeStampEvent1IsRequired: 'Time Stamp Event 1 Is Required',
  Error_TimeStampEvent2IsRequired: 'Time Stamp Event 2 Is Required',
  Error_TargetDurationIsRequired: 'Target Duration Is Required',
  Error_TargetDurationMustBeInDecimalForm: 'Target Duration must be in decimal form',
  Error_RecipientContactNameIsRequired: 'Recipient Contact Name Is Required',
  Error_CompanyNameIsRequired: 'Company Name Is Required',
  Error_RecipientEmailIsRequired: 'Recipient Email Is Required',
  Error_RecipientPhoneIsRequired: 'Recipient Phone Is Required',
  Error_AddressLine1IsRequired: 'Address Line1 Is Required',
  Error_PostalCodeIsRequired: 'Postal Code Is Required',
  Error_CityIsRequired: 'Town/City Is Required',
  Error_StateIsRequired: 'Province/State Is Required',
  Error_ContractIsRequired: 'Contract Is Required',
  Error_AssociatedFleetIsRequired: 'Associated Fleet Is Required',
  Error_AssociatedVesselIsRequired: 'Associated Vessel Is Required',
  Error_VesselETARequired: 'Vessel ETA Required',
  Error_ChargeableIsRequired: 'Chargeable is Required',
  Error_ScreenAccessIsRequired: 'Screen Access is Required',
  Error_TermsAgreementRequired: 'Update Mendatory fields *',
  Error_ValidEmail: 'Please enter a valid email address',
  Error_StatusRequired: 'Status is required',
  Error_CreatingRole: 'Error creating role. duplicate role name.',
  Message_NoComments: 'No Comments',
  PlaceHolder_Comments: 'Your comment here...',
  Placeholder_SelectOption: 'Select option',

  Tooltip_NavigateToStatisticsPage: 'Navigate to Statistics Page',
  Tooltip_View: 'View',
  Tooltip_Edit: 'Edit',
  Tooltip_Delete: 'Delete',
  Tooltip_Feedback: 'Feedback',
  Tooltip_Download: 'Download',
  Tooltip_TimestampEvent: 'Timestamp Events',
  Tooltip_Archive: 'Archive',
  Tooltip_Unarchive: 'Unarchive',
  Tooltip_Default: 'Default',
  Tooltip_DocumentSearch: 'Access BV | Documents',
  Tooltip_KnowledgeCenter: 'Access BV | Knowledge Center',
  Tooltip_AccountSetting: 'Access BV | Account Setting',
  Tooltip_ReportSearch: 'Access BV | Reports',
  Tooltip_NotificationSetting: 'Access BV | Notification Setting',
  Tooltip_Favorite: 'Favorite',
  Tooltip_Unfavorite: 'Unfavorite',
  Tooltip_Export_To_CSV: 'Export to CSV',
  Tooltip_ClientQuotes: 'Access BV | Client Quotes',
  Tooltip_Equipments: 'Access BV | Equipments',
  Tooltip_AddClientQuotes: 'New Client Quotes',
  Tooltip_EditClientQuotes: 'Access BV | Edit Client Quotes',
  Tooltip_DataSchema: 'Access BV | Data Schema',
  Tooltip_AddSubmission: 'New Submission',
  Tooltip_EditSubmission: 'Edit Submission',
  Tooltip_EditDataSchema: 'Access BV | Edit Data Schema',
  Tooltip_TranslationSets: 'Access BV |Translation Sets',
  Tooltip_Translations: 'Translations',
  Tooltip_AddTranslationSets: 'Access BV | Add Translation Sets',
  Tooltip_EditTranslationSets: 'Access BV | Edit Translation Sets',
  Tooltip_EditTarget: 'Edit Target',
  Tooltip_Subscriptions: 'Access BV | Subscriptions',
  Tooltip_EditSubscription: 'Access BV | Edit Subscription',
  Tooltip_Targets: 'Targets',
  Tooltip_CreateAction: 'Create Action',
  Tooltip_APILog: 'Access BV | APILog',
  Tooltip_Destination: 'Destination',
  Tooltip_Setting: 'Setting',
  Tooltip_Authentication: 'Authentication',
  Tooltip_General: 'General',
  Tooltip_AssetManagement: 'Access BV | Asset Management',
  Tooltip_EditLayout: 'Edit Layout',
  Tooltip_UserGroups: 'Access BV | User Groups',
  Tooltip_AddObjectConfiguration: 'Access BV | Add Object Configuration',
  Tooltip_EditObjectConfiguration: 'Access BV | Edit Object Configuration',
  Tooltip_Outbound: 'Access BV | Outbound',
  Tooltip_Client: 'Access BV | Client',
  Tooltip_AddInspectionLocation: 'Access BV | Add Inspection Location',
  Tooltip_EditInspectionLocation: 'Access BV | Edit Inspection Location',
  Tooltip_AddTimestampEvent: 'Access BV | Add Timestamp Event',
  Tooltip_EditTimestampEvent: 'Access BV | Edit Timestamp Event',
  Tooltip_EditConsumable: 'Access BV | Edit Consumables',
  Tooltip_AddConsumable: 'Add Consumable Order',
  Tooltip_Language: 'Language',
  Tooltip_Activity: 'Activity',
  Tooltip_Theme: 'Theme',
  Tooltip_Profile: 'Profile',
  Tooltip_Navigate: 'Navigate',
  Tooltip_Refresh: 'Refresh',
  Text_TermsAgreement: 'I agree that client personal data may be collected and processed for the purpose of sending emails or reports etc *',
  Tooltip_Filters: 'Filters',
  Tooltip_AuditHistory: 'Audit History',

  Tab_AllDocuments: 'Documents and instruction manuals',
  Tab_UserDocuments: 'User Documents',
  Tab_SubmissionForm: 'Submission Forms',
  Tab_LatestNews: 'Latest News',
  Tab_NewsArchived: 'News Archived',
  Tab_Laboratory_Reports: 'Laboratory Reports',
  Tab_Data: 'Data',
  Tab_Invoices: 'Invoices',
  Tab_Other: 'Other',
  Tab_Documents: 'Documents',
  Tab_News: 'News',
  Tab_Design: 'Design',
  Tab_Code: 'Code',
  Tab_Decoration: 'Decoration',
  Tab_Conditions: 'Conditions',
  Tab_Translation: 'Translation',
  Tab_Title_AppName: 'CTD AccessBV',
  Tab_General: 'General',
  Tab_Profile: 'Profile',
  Tab_Notifications: 'Notifications',
  Tab_Inspection_Reports: 'Inspection Reports',
  Tab_Nominations: 'Nominations',
  Tab_Photos: 'Photos',
  Tab_All: 'All',
  Tab_New: 'New',
  Tab_InProgress: 'InProgress',
  Tab_Completed: 'Completed',
  Placeholder_Selectanoption: 'Select an option',
  Text_AddClientQuotes: 'New Client Quotes',
  Text_EditClientQuotes: 'Edit Client Quotes',
  Text_Trigger: 'Trigger',
  Text_EditDataSchemas: 'Edit Data Schemas',
  Text_AddSubmissions: 'Add Submissions',
  Text_EditSubmissions: 'Edit Submissions',
  Text_AddTranslationSets: 'Add Translation Sets',
  Text_EditTranslationSets: 'Edit Translation Sets',
  Text_EditTarget: 'Edit Target',
  Text_EditSubscriptions: 'Edit Subscriptions',
  Text_AddInspectionLocation: 'Add Inspection Location',
  Text_EditInspectionLocation: 'Edit Inspection Location',
  Text_AddTimestampEvent: 'Add Timestamp Event',
  Text_EditTimestampEvent: 'Edit Timestamp Event',
  Text_QuantityDisplayListExported: 'QuantityDisplay_List_Exported',
  Text_Consumable: 'Consumable',
  Text_Edit: 'Edit',
  Text_EditRole: 'Edit Role',
  Text_AddRole: 'Add Role',
  Text_RoleName: 'Role Name',

  Axis_TurnaroundTime: 'Turnaround Time (days)',
  Label_Username: 'User Name',
  Label_VesselETA: 'Vessel ETA',
  Label_OrderReceived: 'Order Received',
  Label_Import_CSV: 'Import CSV',
  Label_belongsTo: 'Belongs To',
  Label_dateCreatedFrom: 'Date Created From',
  Label_dateCreatedTo: 'Date Created To',
  Label_View_Details: 'View Detail',
  Label_View_Feedback: 'Feedback',
  Label_reportsFor: 'Reports For',
  Label_ReportsFor: 'Reports For',
  Label_Add_Submission_Contacts: 'Submission Contacts',
  Label_Add_Sample_List: 'Sample List',
  Label_Add_Storage: 'Storage',
  Label_Template_Name: 'Template Name',
  Label_BelongsTo: 'Belongs To',
  Label_RecordID: 'Record ID',
  Label_Add: 'Add',
  Label_Save: 'Save',
  Label_ViewMore: 'View More',
  Label_ViewLess: 'View Less',
  Label_Inbound: 'Inbound',
  Label_Outbound: 'Outbound',
  Label_No_Records_Found: 'No records found!',
  Label_No_Invoice_Found: 'No invoice found',
  Label_StorageType: 'Storage Type',
  Label_StorageName: 'Storage Name',
  Label_Transit: 'Transit',
  Label_ContractName: 'Contract Name',
  Label_PO: 'PO',
  Label_SiteLocation: 'Site Location',
  Dialog_Title_FeedbackHeader: 'Feedback for',
  Dialog_Title_NewActionForJob: 'New Action For Job {{name}}',
  Dialog_Title_NewActionForSample: 'New Action For Sample {{name}}',
  Dialog_Title_NewActionForInvoice: 'New Action For Invoice {{name}}',
  Dialog_Title_NewActionForReport: 'New Action For Report {{name}}',
  Dialog_Title_NewActionForConsumableOrder: 'New Action For ConsumableOrder {{name}}',
  Dialog_Title_NewActionForSampleTracking: 'New Action For Sample Tracking {{name}}',
  Dialog_Title_NewActionForCylinder: 'New Action For Cylinder {{name}}',
  Dialog_Title_NewActionForOrderRequest: 'New Action For OrderRequest {{name}}',
  Dialog_Title_NewActionForOrder: 'New Action For Order {{name}}',

  Title_NewSubscription: 'New Subscription',
  Title_NewTarget: 'New Target',
  Title_NewHeader: 'New Header',
  Title_Showing_X_Records: 'Showing {{length}} record(s)',
  Title_General: 'General',
  Title_UserDetail: 'User Details',
  Title_DeliveryDetails: 'Delivery Details',
  Title_RecurringOrderSchedule: 'Recurring Order Schedule',
  Title_Access: 'Access',
  Title_NewTranslationSets: 'New Translation Sets',
  Title_NewUserGroup: 'New User Group',
  Title_AddTimeLogCalculation: 'Add Time Log Calculation',
  Title_EditTimeLogCalculation: 'Edit Time Log Calculation',
  Title_ApplicationAccess: 'Application Access',
  Title_ShippingDetails: 'Shipping Details',
  Title_OrderDetails: 'Order Details',

  Status_New: 'New',
  Status_Created: 'Created',
  Status_ReadyForAnalysis: 'Ready For Analysis',
  Status_AnalysisStarted: 'Analysis Started',
  Status_QCChecked: 'QC Checked',
  Status_JobFinished: 'Job Finished',
  Status_InAnalysis: 'In Analysis',
  Status_InPrep: 'In Prep',
  Status_InProgress: 'In Progress',
  Status_Scheduled: 'Scheduled',
  Status_Completed: 'Completed',
  Status_Sampled: 'Sampled',
  Status_Started: 'Started',
  'Status_Not Sampled': 'Not Sampled',
  Status_Complete: 'Complete',
  'Status_In Progress': 'In Progress',
  Recent_News: 'Recent News',
  In_Prep_Count: 'IN PREP',
  In_Transit_Count: 'IN TRANSIT',
  In_Analysis_Count: 'IN ANALYSIS',
  Job_Age_Count: 'JOB AGE',
  In_Stats: 'IN',
  Out_Stats: 'OUT',
  Site_Map: 'Site(s)',
  Turnaround_Time: 'Turnaround Time',
  Recent_Jobs: 'Recent Jobs',
  Recent_News_Description: 'Recent news description',
  Site_Map_Description: 'Site map description',
  In_Prep_Count_Description: 'IN PREP description',
  In_Transit_Count_Description: 'IN TRANSIT description',
  In_Analysis_Count_Description: 'IN ANALYSIS description',
  Job_Age_Count_Description: 'JOB AGE description',
  In_Stats_Description: 'IN Stats Description',
  Out_Stats_Description: 'OUT Stats description',
  Recent_Jobs_Description: 'Recent Jobs description',
  Turnaround_Time_Description: 'This will show job turn around time',
  DocumentTypeID: 'Document Type ID',
  CreatedOn: 'Created On',
  CreatedBy: 'Created By',
  document: 'document',
  Active: 'Active',
  No_items_found: 'No items found',
  LastUpdatedOn: 'Last Updated On',
  LastUpdatedBy: 'Last Updated By',
  new: 'new',
  feedback: 'feedback',
  No_Feedback_Found: 'No Feedback Found',
  Note_displayed_and_downloaded: 'Files can be displayed and downloaded in knowledge center section.',
  File: 'File',
  browse: 'browse',
  thorough_your_machine: 'thorough your machine',
  Label_Select_File: 'Select file',
  Label_Select_Files: 'Select files',
  Label_Drop_File: 'Drop file',
  Label_Drop_Files: 'Drop files',
  InvoiceDetails: 'InvoiceDetails',

  // Activity Center translations
  ActivityCenter_Activity: 'Activity',
  ActivityCenter_NoActiveTasks: 'No Active Tasks',
  ActivityCenter_Status_complete: 'Complete',
  ActivityCenter_Status_queued: 'Queued',
  ActivityCenter_Status_inProgress: 'In Progress',
  ActivityCenter_Status_completed: 'Completed',
  ActivityCenter_Status_failed: 'Failed',
  ActivityCenter_Status_Success: 'Success',
  ActivityCenter_ViewReport: 'View Report',
  ActivityCenter_RecordsProcessed: 'Records Processed',
  ActivityCenter_TechnicalDetails: 'Technical Details',
  ActivityCenter_ClearTask: 'Clear Task',
};

export default enTranslation;
